import { render, staticRenderFns } from "./safetyGearGive.vue?vue&type=template&id=04b9f1fb"
import script from "./safetyGearGive.vue?vue&type=script&lang=js"
export * from "./safetyGearGive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b9f1fb')) {
      api.createRecord('04b9f1fb', component.options)
    } else {
      api.reload('04b9f1fb', component.options)
    }
    module.hot.accept("./safetyGearGive.vue?vue&type=template&id=04b9f1fb", function () {
      api.rerender('04b9f1fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearGive.vue"
export default component.exports